export const ICON_URL = "http://cdn.dashnet.org/cookieclicker/beta/img/icons.png?v=2.052";
export const ICON_SIZE = 18;
export const INFO_BLOCK_SIZE = 16;
export const INFO_BLOCK_FONT_SIZE = 12;
export const COLOR_RGB = {
    red: [255, 42, 75],
    green: [2, 253, 2],
};
export const COLORS = {
    red: `rgb(${COLOR_RGB.red.join(", ")})`,
    green: `rgb(${COLOR_RGB.green.join(", ")})`,
};
export const SHORT_BUFF_NAMES = {
    "frenzy": "F",
    "click_frenzy": "CF",
    "dragon_harvest": "DH",
    "dragonflight": "DF",
    "cursed_finger": "CuF",
    "cookie_storm": "CS",
    "blood_frenzy": "EF",
    "sugar_frenzy": "SF",
    "sugar_blessing": "SB",
    "loan_1": "L1",
    "loan_2": "L2",
    "loan_3": "L3",
    "loan_1_interest": "L1 (I)",
    "loan_2_interest": "L2 (I)",
    "loan_3_interest": "L3 (I)",
    "haggler_luck": "Hagglers (+)",
    "pixie_luck": "Pixies (+)",
    "magic_adept": "DI (+)",
    "haggler_misery": "Hagglers (-)",
    "pixie_misery": "Pixies (-)",
    "magic_inept": "DI (-)",
};
export const MULT_CLICK_IDS = [
    "click_frenzy",
    "dragonflight",
    "cursed_finger",
    "devastation",
];
export const BUILDING_NAMES = [
    "Cursor",
    "Grandma",
    "Farm",
    "Mine",
    "Factory",
    "Bank",
    "Temple",
    "Wizard Tower",
    "Shipment",
    "Alchemy Lab",
    "Portal",
    "Time Machine",
    "Antim. Condenser",
    "Prism",
    "Chancemaker",
    "Fractal engine",
    "Javascript console",
    "Idleverse",
    "Cortex baker",
    "You"
];
